// src/contexts/UserContext.js
import React, { createContext, useState, useEffect, useCallback } from "react";
import { getToken, fetchUserProfile } from "../utils";
import { useNavigate } from "react-router-dom";
import ErrorModal from "../components/ErrorModal";

export const UserContext = createContext();

export const UserProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [error, setError] = useState(null);
  const [showAuthErrorModal, setShowAuthErrorModal] = useState(false);
  const [authErrorMessage, setAuthErrorMessage] = useState("");
  const [redirectCountdown, setRedirectCountdown] = useState(10);

  const navigate = useNavigate();

  // Fonction pour gérer l'erreur d'authentification
  const handleAuthError = useCallback(
    (message) => {
      setError(message);
      setAuthErrorMessage(message);
      localStorage.removeItem("token");
      setShowAuthErrorModal(true);

      // Compte à rebours pour la redirection
      let countDown = 10;
      setRedirectCountdown(countDown);

      const timer = setInterval(() => {
        countDown -= 1;
        setRedirectCountdown(countDown);

        if (countDown <= 0) {
          clearInterval(timer);
          setShowAuthErrorModal(false);
          navigate("/login");
        }
      }, 1000);
    },
    [navigate]
  );

  useEffect(() => {
    // reccuperer l'url de la page actuelle
    // Par ceci :
    const currentPath =
      window.location.pathname !== "/login"
        ? window.location.pathname +
          window.location.search +
          window.location.hash
        : "/";
    sessionStorage.setItem("currentUrl", currentPath);

    const fetchProfile = async () => {
      const token = getToken();

      if (!token) {
        navigate("/login");
        return;
      }

      try {
        const userData = await fetchUserProfile(token);
        if (!userData) {
          handleAuthError("Session expirée. Veuillez vous reconnecter.");
          return;
        }
        setUser(userData);
      } catch (err) {
        // remove token from local storage if there's an error
        handleAuthError("Problème de connexion. Veuillez vous reconnecter.");
      }
    };

    fetchProfile();
  }, [navigate, handleAuthError]);

  return (
    <UserContext.Provider value={{ user, error }}>
      {/* Modal d'erreur d'authentification */}
      <ErrorModal
        open={showAuthErrorModal}
        onClose={() => {
          setShowAuthErrorModal(false);
          navigate("/login");
        }}
        errors={{
          "Erreur d'authentification": authErrorMessage,
          "Redirection automatique dans": `${redirectCountdown} seconde${
            redirectCountdown > 1 ? "s" : ""
          }`,
        }}
      />
      {children}
    </UserContext.Provider>
  );
};
